import React, { useState, useEffect, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar } from 'reactstrap';
import { endOfMonth, startOfMonth } from 'date-fns';
import DateField from '../../../shared/components/form/DateField';

const BalanceSmartPayFilter = (props) => {
  const { lastFilter, initialize, t, filterClick } = props;

  const [filter, setFilter] = useState({
    initialDate: startOfMonth(new Date()),
    finalDate: endOfMonth(new Date()),
  });

  const filterChange = (field, value) => {
    const updatedFilter = { ...filter };
    updatedFilter[field] = value;
    setFilter(updatedFilter);
  };

  useEffect(() => {
    if (lastFilter) {
      setFilter(lastFilter);
      initialize(lastFilter);
    } else {
      initialize(filter);
    }
  }, []);

  return (
    <Fragment>
      <form className="form">
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="initialDate"
                component={DateField}
                value={filter.initialDate}
                onChange={(value) => filterChange('initialDate', value)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.final_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="finalDate"
                component={DateField}
                value={filter.finalDate}
                minDate={filter.initialDate}
                onChange={(value) => filterChange('finalDate', value)}
              />
            </div>
          </div>
        </div>
      </form>
      <ButtonToolbar className="filter-button">
        <Button color="success" onClick={() => filterClick(filter)}>
          {t('general.filter')}
        </Button>
      </ButtonToolbar>
    </Fragment>
  );
};

BalanceSmartPayFilter.propTypes = {
  t: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  lastFilter: PropTypes.shape(PropTypes.shape),
};

BalanceSmartPayFilter.defaultProps = {
  lastFilter: null,
};

export default reduxForm({
  form: 'BalanceSmartPayFilter',
})(withTranslation('common')(BalanceSmartPayFilter));
